export default "__VITE_ASSET__DK_tx$K8__"